/**
 * Safely trigger a Facebook Pixel custom event
 * @param eventName - The name of the custom event
 * @param parameters - Optional parameters to send with the event
 */
export const trackPixelEvent = async (eventName: string, parameters?: Record<string, any>): Promise<void> => {
  await fetch('https://soloom-an-695091668299.europe-west2.run.app', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({'event': eventName})
  });
};

/**
 * Track quiz started event
 */
export const trackQuizStarted = (): void => {
  trackPixelEvent('quiz_started');
};

/**
 * Track quiz ended event (when user reaches email form)
 */
export const trackQuizEnded = (): void => {
  trackPixelEvent('quiz_ended');
};

/**
 * Track application submission event
 * @param userData - User data submitted with the form
 */
export const trackSubmitApplication = (userData?: { email?: string; forename?: string }): void => {
  const parameters: Record<string, any> = {};

  if (userData?.email) {
    parameters.email = userData.email;
  }

  if (userData?.forename) {
    parameters.first_name = userData.forename;
  }

  trackPixelEvent('submit_form', parameters);
};
